// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"AddNewGoalPop_AddNewGoalPop__O7wKT","modalBody":"AddNewGoalPop_modalBody__vgNn8","formControl":"AddNewGoalPop_formControl__uCsTs","add":"AddNewGoalPop_add__KcLou"};